/**
 * BuildVersion — the deployed build number, shown in page footers.
 *
 * The label is `major.minor.patch` (three places) taken from
 * package.json at build time, plus the build stamp as a tooltip so
 * support can tell two deploys of the same version apart.
 * See vite.config.ts → define.
 */

export const APP_VERSION_LABEL =
  typeof __APP_VERSION_LABEL__ !== 'undefined' ? __APP_VERSION_LABEL__ : '0.0.0'

const BUILD_STAMP =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'

export default function BuildVersion({ className = '' }: { className?: string }) {
  return (
    <span
      className={`build-version ${className}`.trim()}
      title={`Build ${BUILD_STAMP}`}
    >
      v{APP_VERSION_LABEL}
    </span>
  )
}
